/**
 * Checks if the value is a number.
 * Will return false for NaN and Number objects. ex. new Number(1)
 */
export function isNumber(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
/**
 * Checks if the value is a string.
 * Will return false for string objects. ex. new String('1')
 */
export function isString(value) {
    return typeof value === 'string';
}
/**
 * Checks if the value is an executable function.
 */
export function isFunction(value) {
    return typeof value === 'function';
}
/**
 * Checks if the value is an object. ex. { a: 1 }
 * Will not return true for arrays or other weird "object" types
 */
export function isObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Checks if the value is a pure boolean value (true or false)
 * Will return false for Boolean objects. ex. new Boolean(true)
 */
export function isBoolean(value) {
    return typeof value === 'boolean';
}
/**
 * Returns true if the value is null.
 */
export function isNull(value) {
    return value === null;
}
/**
 * Returns true if the value is undefined.
 */
export function isUndefined(value) {
    return value === undefined;
}
/**
 * Returns true when a value is not null and not undefined
 */
export function isPresent(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=typeGuards.js.map